module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_6005.f4778063.png";